import { useState, useEffect, Fragment } from 'react'
import { Link, NavLink, useNavigate } from "react-router-dom";
// import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import { Dialog, Popover, Menu, Transition, Disclosure } from '@headlessui/react'
import { Bars3Icon, XMarkIcon, UserIcon, MagnifyingGlassIcon, BellIcon,ChevronDownIcon, ChevronRightIcon } from '@heroicons/react/24/outline'
import Cart from '../inc/Cart'
// import Search from '../inc/Search'
import Logo from '../../images/logo.png'



const navigation = [
  { name: 'Accueil', href: '/' },
  { name: 'Nouvelle Collection', href: '/new-collection' },
  { name: 'A propos de nous', href: '/about-us' },
  { name: 'Contactez-nous', href: '/contact-us' },
]

// function classNames(...classes) {
//     return classes.filter(Boolean).join(' ')
// }

export default function Header({ cart, setCart, handleChange, categories }) {
  let navigate = useNavigate()

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  const [navSize, setnavSize] = useState("10rem");
  const [navColor, setnavColor] = useState("transparent");
  const listenScrollEvent = () => {
    window.scrollY > 50 ? setnavColor("#ffff") : setnavColor("transparent");
    window.scrollY > 50 ? setnavSize("5rem") : setnavSize("6rem");
  };
  useEffect(() => {
    window.addEventListener("scroll", listenScrollEvent);
    return () => {
      window.removeEventListener("scroll", listenScrollEvent);
    };
  }, []);

  const handleLogout = () => {
          // Clear the authentication token here
      navigate('/');
  };

  return (
    <div className="bg-white">
      <header className="fixed inset-x-0 top-0 z-50 " style={{
          backgroundColor: navColor,
          height: navSize,
          transition: "all 1s"}}>
        <nav className="flex items-center justify-between p-4 lg:px-12" aria-label="Global">
          <div className="flex lg:flex">
            <Link to="/" className="-m-1.5 p-1.5">
              <span className="sr-only">Rokasa Collection</span>
              {/* ROKASA */}
              <img className="h-14 w-auto" src={Logo} alt="" /> 
            </Link>
          </div>
          <div className="flex lg:hidden">
          <div className='pr-2'>
            <div className="flex flex-1 justify-end gap-x-2">
                <Cart cart={cart} setCart={setCart} handleChange={handleChange} />
                <Menu as="div" className="relative">
                <div>
                  <Menu.Button className="text-sm font-semibold leading-6 text-gray-900 bg-white rounded-full shadow px-2.5 py-2">
                    <span className="absolute -inset-1.5" />
                        <span className="sr-only">Open user menu</span>
                        {/* <img className="h-8 w-8 rounded-full" src={user.imageUrl} alt="" /> */}
                        <UserIcon className="h-6 w-6" aria-hidden="true"/>
                      </Menu.Button>
                    </div>
                   <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95" >
                      <Menu.Items className="absolute right-0 z-10 text-start mt-2 w-36 origin-top-right rounded-md bg-white p-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                      <Menu.Item >
                            <Link to={`/profile`}
                                  className='block w-full px-4 py-1 text-sm text-center leading-7 hover:bg-gray-100 text-gray-900' >
                                Votre profil
                            </Link>
                        </Menu.Item>
                        <Menu.Item >
                            <button onClick={handleLogout}
                                  className='block w-full px-4 py-1 text-sm leading-7 hover:bg-gray-100 text-gray-900'>
                                Se deconnecter
                            </button>
                        </Menu.Item>
                    </Menu.Items>
                  </Transition>
                </Menu>
                {/* <Link to="/sign-in" className="text-sm font-semibold leading-6 text-gray-900 bg-white rounded-full shadow px-4 py-2">
                Se connecter
                </Link> */}
            </div>
          </div>
          
            <button
              type="button"
              className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
              onClick={() => setMobileMenuOpen(true)}
            >
              <span className="sr-only">Open main menu</span>
              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div className="hidden lg:flex lg:pl-5 lg:gap-x-4">
              <NavLink key='Accueil' to={`/`} 
                className={({ isActive }) => (isActive ? "text-sm font-semibold leading-6 py-1 text-gray-900 border-b-2 border-gray-900" : 'text-sm font-semibold leading-6 py-1 text-gray-900 hover:border-b-2 hover:border-gray-900')}
                >
                Accueil
              </NavLink>
              <NavLink key='Nouvelle Collection' to={`/new-collection`} 
                className={({ isActive }) => (isActive ? "text-sm font-semibold leading-6 py-1 text-gray-900 border-b-2 border-gray-900" : 'text-sm font-semibold leading-6 py-1 text-gray-900 hover:border-b-2 hover:border-gray-900')}
                >
                Nouvelle Collection
              </NavLink>
              <Popover className="relative">
                <Popover.Button className="inline-flex items-center gap-x-1 text-sm font-semibold leading-6 py-1 text-gray-900 hover:border-b-2 hover:border-gray-900">
                  <span>Catégories</span>
                  <ChevronDownIcon className="h-5 w-5 pt-1"/>
                </Popover.Button>

                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-200"
                  enterFrom="opacity-0 translate-y-1"
                  enterTo="opacity-100 translate-y-0"
                  leave="transition ease-in duration-150"
                  leaveFrom="opacity-100 translate-y-0"
                  leaveTo="opacity-0 translate-y-1"
                >
                  <Popover.Panel className="absolute left-1/2 z-10 mt-5 flex w-screen max-w-xs -translate-x-1/2 px-4">
                    <div className="w-screen max-w-xs flex-auto overflow-hidden rounded-xl bg-white text-sm leading-6 shadow-lg ring-1 ring-gray-900/5">
                      <div className="p-2">
                        {categories.map((item) => (
                          <div key={item.name} className="group relative flex gap-x-6 rounded-lg p-2 hover:bg-gray-100"> 
                            <div>
                              <Link to={`/${item.slug}`} className="font-semibold text-gray-900" >
                                {item.name}
                                <span className="absolute inset-0" />
                              </Link>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </Popover.Panel>
                </Transition>
              </Popover>
              <NavLink key='A propos de nous' to={`/about-us`} 
                className={({ isActive }) => (isActive ? "text-sm font-semibold leading-6 py-1 text-gray-900 border-b-2 border-gray-900" : 'text-sm font-semibold leading-6 py-1 text-gray-900 hover:border-b-2 hover:border-gray-900')}
                >
                A propos de nous
              </NavLink>
              <NavLink key='Contactez-nous' to={`/contact-us`} 
                className={({ isActive }) => (isActive ? "text-sm font-semibold leading-6 py-1 text-gray-900 border-b-2 border-gray-900" : 'text-sm font-semibold leading-6 py-1 text-gray-900 hover:border-b-2 hover:border-gray-900')}
                >
                Contactez-nous
              </NavLink>
          </div>
          <div className='hidden lg:flex lg:flex-1 lg:justify-end lg:gap-x-2'>
            <form className="max-w-sm ">
            <div className="relative">
                <MagnifyingGlassIcon className='absolute top-0 bottom-0 w-6 h-6 my-auto text-gray-900 left-3' />
                <input
                    type="text"
                    placeholder="Rechercher"
                    className="w-full py-2 pl-12 text-gray-500 shadow hover:shadow-md rounded-full border-none outline-none bg-gray-50 focus:bg-white focus:border-gray-900 focus:rign-2 focus:ring-black"
                />
            </div>
            </form>

            {/* <Search products={products}/> */}
            <Cart cart={cart} setCart={setCart} handleChange={handleChange}/>
            <Menu as="div" className="relative">
                <div>
                  <Menu.Button className="text-sm font-semibold leading-6 text-gray-900 bg-white rounded-full shadow hover:shadow-md px-2.5 py-2">
                    <span className="absolute -inset-1.5" />
                        <span className="sr-only">Open user menu</span>
                        {/* <img className="h-8 w-8 rounded-full" src={user.imageUrl} alt="" /> */}
                        <UserIcon className="h-6 w-6" aria-hidden="true"/>
                      </Menu.Button>
                    </div>
                   <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95" >
                      <Menu.Items className="absolute right-0 z-10 text-start mt-2 w-36 origin-top-right rounded-md bg-white p-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                        <Menu.Item >
                            <Link to={`/profile`}
                                  className='block w-full px-4 py-1 text-sm text-center leading-7 hover:bg-gray-100 text-gray-900' >
                                Votre profil
                            </Link>
                        </Menu.Item>
                        <Menu.Item >
                            <button onClick={handleLogout}
                                  className='block w-full px-4 py-1 text-sm leading-7 hover:bg-gray-100 text-gray-900'>
                                Se deconnecter
                            </button>
                        </Menu.Item>
                    </Menu.Items>
                </Transition>
            </Menu>
            <Link to="/sign-in" className="text-sm font-semibold leading-6 text-gray-900 bg-white rounded-full shadow hover:shadow-md px-4 py-2">
              Se connecter
            </Link>
            
          </div>
        </nav>
        <Dialog as="div" className="lg:hidden" open={mobileMenuOpen} onClose={setMobileMenuOpen}>
          <div className="fixed inset-0 z-50" />
          <Dialog.Panel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
            <div className="flex items-center justify-between">
              <Link to="/" className="-m-1.5 p-1.5">
              <span className="sr-only">Rokasa Collection</span>
              <img className="h-8 w-auto" src={Logo} alt="" /> 
              </Link>
              <button
                type="button"
                className="-m-2.5 rounded-md p-2.5 text-gray-700"
                onClick={() => setMobileMenuOpen(false)}
                >
                <span className="sr-only">Close menu</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
            <div className="mt-6 flow-root">
              <div className="-my-6 divide-y divide-gray-500/10">
                <div className="space-y-2 py-6">
                    <Link
                      key='Accueil'
                      to={`/`}
                      onClick={() => setMobileMenuOpen(false)}
                      className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-100"
                      >
                      Accueil
                    </Link>
                    <Link
                      key='Nouvelle collection'
                      to={`/new-collection`}
                      onClick={() => setMobileMenuOpen(false)}
                      className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-100"
                      >
                      Nouvelle collection
                    </Link>
                    <Disclosure>
                      {({ open }) => (
                        /* Use the `open` state to conditionally change the direction of an icon. */
                        <>
                          <Disclosure.Button  className="-mx-3 flex items-center justify-between w-full rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-100">
                            Catégories
                            <ChevronRightIcon className={open ? 'rotate-90 transform w-5' : 'w-5'} />
                          </Disclosure.Button>
                          <Transition
                            enter="transition duration-100 ease-out"
                            enterFrom="transform scale-95 opacity-0"
                            enterTo="transform scale-100 opacity-100"
                            leave="transition duration-75 ease-out"
                            leaveFrom="transform scale-100 opacity-100"
                            leaveTo="transform scale-95 opacity-0"
                          >
                          <Disclosure.Panel>
                          <div className="p-2">
                          {categories.map((item) => (
                            <div key={item.name} className="group relative flex gap-x-6 rounded-lg p-2 hover:bg-gray-100"> 
                              <div>
                                <Link to={`/${item.slug}`} className="font-semibold text-gray-900" >
                                  {item.name}
                                  <span className="absolute inset-0" />
                                </Link>
                              </div>
                            </div>
                          ))}
                        </div>
                          </Disclosure.Panel>
                          </Transition>
                        </>
                      )}
                    </Disclosure>
                    <Link
                      key='A propos de nous'
                      to={`/about-us`}
                      onClick={() => setMobileMenuOpen(false)}
                      className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-100"
                      >
                      A propos de nous
                    </Link>
                    <Link
                      key='Contactez-nous'
                      to={`/contact-us`}
                      onClick={() => setMobileMenuOpen(false)}
                      className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-100"
                      >
                      Contactez-nous
                    </Link>
                </div> 
              </div>
            </div>
          </Dialog.Panel>
        </Dialog>
      </header>
    </div>
  )
}
